import EPGRegionForm from './EPGRegionForm';

export * from './EPGRegionForm';

export default EPGRegionForm;
